var sliderMatiere = document.getElementById('sliderMatiere');
var flktyMatiere = new Flickity( sliderMatiere, {
    cellAlign: 'left',
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
});
var sliderMove = document.querySelector('.slider_movement01');
var flktyMove = new Flickity( sliderMove, {
    cellAlign: 'left',
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: 'm95.24,47.82H10.15l16.51-16.51c.88-.88.88-2.32,0-3.2s-2.32-.88-3.2,0L3.19,48.37c-.42.42-.66,1-.66,1.6s.24,1.18.66,1.6l20.27,20.27c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.88-.88.88-2.32,0-3.2l-16.29-16.29h84.86c1.25,0,2.26-1.01,2.26-2.26s-1.01-2.26-2.26-2.26Z'
});
var sliderAccess = document.querySelector('.slider-access');
var flktyAccess = new Flickity( sliderAccess, {
    cellAlign: 'left',
    imagesLoaded: true,
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: true,
    arrowShape: 'm95.24,47.82H10.15l16.51-16.51c.88-.88.88-2.32,0-3.2s-2.32-.88-3.2,0L3.19,48.37c-.42.42-.66,1-.66,1.6s.24,1.18.66,1.6l20.27,20.27c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.88-.88.88-2.32,0-3.2l-16.29-16.29h84.86c1.25,0,2.26-1.01,2.26-2.26s-1.01-2.26-2.26-2.26Z'
});

document.addEventListener('DOMContentLoaded', function() {
    const words = document.querySelectorAll('.fadeUpEffect');
    const lines = document.querySelectorAll('.line_container .line');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fadeInUp');
                observer.unobserve(entry.target); // Stop observing once the animation has been triggered
            }
        });
    });
    const observer1 = new IntersectionObserver(entries1 => {
        entries1.forEach(entry1 => {
            if (entry1.isIntersecting) {
                entry1.target.classList.add('drawn');
                observer1.unobserve(entry1.target); // Stop observing once the animation has been triggered
            }
        });
    });

    words.forEach(word => {
        observer.observe(word);
    });
    lines.forEach(line => {
        observer1.observe(line);
    });

    const pastilles = document.querySelectorAll('.flex_pastilles .past');
    const pastillesContainer = document.querySelector('.flex_pastilles');

    if (pastilles.length > 3) {
        pastillesContainer.classList.add('two-lines');
    }
});
// document.addEventListener('scroll', function() {
//     const parallaxElement = document.querySelector('.box-move .image_container img');
//     const scrollPosition = window.pageYOffset;

//     // Ajustez la vitesse de l'effet parallaxe ici (plus le nombre est bas, plus l'effet est lent)
//     const parallaxSpeed = 0.5;

//     parallaxElement.style.transform = 'translateY(' + (scrollPosition * parallaxSpeed) + 'px)';
// });


function changeCollection(evt, catName) {
    var i, x, catBtn;
    
    // Cacher toutes les collections
    x = document.getElementsByClassName("collection");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
  
    // Réinitialiser les boutons de catégorie
    catBtn = document.getElementsByClassName("cat-btn");
    for (i = 0; i < catBtn.length; i++) {  // Utilisation de catBtn.length
      catBtn[i].className = catBtn[i].className.replace(" active", "");
    }
  
    // Afficher la collection sélectionnée et activer le bouton correspondant
    document.getElementById(catName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  

document.addEventListener('DOMContentLoaded', function() {
    // Tout ce qui concerne l'animation des mots et des lignes
    const words = document.querySelectorAll('.fadeUpEffect');
    const lines = document.querySelectorAll('.line_container .line');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('fadeInUp');
                observer.unobserve(entry.target);
            }
        });
    });

    const observer1 = new IntersectionObserver(entries1 => {
        entries1.forEach(entry1 => {
            if (entry1.isIntersecting) {
                entry1.target.classList.add('drawn');
                observer1.unobserve(entry1.target);
            }
        });
    });

    words.forEach(word => observer.observe(word));
    lines.forEach(line => observer1.observe(line));

    const pastilles = document.querySelectorAll('.flex_pastilles .past');
    const pastillesContainer = document.querySelector('.flex_pastilles');

    if (pastilles.length > 3) {
        pastillesContainer.classList.add('two-lines');
    }
});
function hideAllCollections() {
    const collections = document.querySelectorAll('.collection');
    collections.forEach(collection => {
        collection.classList.remove('active'); // Retire la classe active de toutes les collections
    });
}

function showCollection(collectionId) {
    hideAllCollections(); // Masque toutes les collections
    const collection = document.getElementById(collectionId); // Sélectionne la collection à afficher
    if (collection) {
        collection.classList.add('active'); // Ajoute la classe active pour afficher cette collection

        // Initialiser Flickity pour chaque slider de la collection affichée
        const sliders = collection.querySelectorAll('.slider_movement');
        sliders.forEach(slider => {
            new Flickity(slider, {
                cellAlign: 'left',
                contain: true,
                imagesLoaded: true,
                wrapAround: true,
                pageDots: false,
                prevNextButtons: true,
                arrowShape: 'm95.24,47.82H10.15l16.51-16.51c.88-.88.88-2.32,0-3.2s-2.32-.88-3.2,0L3.19,48.37c-.42.42-.66,1-.66,1.6s.24,1.18.66,1.6l20.27,20.27c.44.44,1.02.66,1.6.66s1.16-.22,1.6-.66c.88-.88.88-2.32,0-3.2l-16.29-16.29h84.86c1.25,0,2.26-1.01,2.26-2.26s-1.01-2.26-2.26-2.26Z'
            });
        });
    }
}

// Ajouter des événements dynamiquement
document.querySelectorAll('.cat-btn').forEach(button => {
    button.addEventListener('click', function() {
        const collectionId = this.id.replace('-btn', '');
        showCollection(collectionId);
    });
});
